import styled from "styled-components";

export const Container = styled.div`
	font-family: var(--font-family-metropolis);
	background-color: var(--neutral-stronger);
	color: var(--neutral-smoothest);
	border-radius: 8px;
	overflow: hidden;
	width: 156px;
	height: 264px;
	padding: 16px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	@media only screen and (max-width: 800px) {
		margin-bottom: 1rem;
	}
`;

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;

export const Banner = styled.img`
	width: 80px;
	height: 80px;
	border-radius: 8px;
`;

export const Title = styled.label`
	font-size: var(--font-size-default);
	font-weight: 600;
	text-align: center;
	padding-top: 8px;
	line-height: 160%;
	white-space: break-spaces;
	text-overflow: ellipsis;
	width: 100%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;

export const Body = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Price = styled.label`
	display: flex;
	padding: 4px 8px;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	border: 1px solid var(--neutral-strong, #353546);

	color: var(--brand-primary, #01e59b);
	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
`;

export const Button = styled.button`
	color: var(--brand-primary);
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: var(--font-size-small);
	font-weight: 600;
	line-height: 170%;

	background: none;
	border: none;
	text-decoration: none;

	&:focus {
		outline: none !important;
	}
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	background-color: var(--neutral-strong);
	border-radius: 4px;
	padding: 5px 20px;
`;
